<template>
  <div>
    <transition-group name="fade">
      <div
        class="selection-wrapper"
        v-for="(selectedVariable, index) in getSelectedVariables"
        :key="index">
        <formula-constant-field
          v-model="selectedVariable.model"
          v-if="selectedVariable.isConstant"
          :operators="operators"
          :hideOperator="hideOperator(index)"
        />
        <formula-field-selector
          v-else
          class="selection-left"
          v-model="selectedVariable.model"
          :variables="selectedVariable.options"
          :operators="operators"
          :isConstant="selectedVariable.isConstant"
          :hideOperator="hideOperator(index)"
          :variableOperations="variableOperations"
        />
        <font-awesome-icon
          class="selection-right"
          v-on:click="onClickRemoveVariable(index)"
          :icon="icon.remove"/>
      </div>
    </transition-group>

    <div
      class="add-wrapper">
      <btn-pill
        :disabled="isAddButtonDisabled()"
        v-on:click="onClickAddVariable()"
        btn-size="s"
        btn-type="secondary">
        <font-awesome-icon :icon="icon.add"/>
        {{ $t('health.challenge.addVariable') }}
      </btn-pill>

      <btn-pill
        v-on:click="onClickAddConstant()"
        btn-size="s"
        btn-type="secondary">
        <font-awesome-icon :icon="icon.add"/>
        {{ $t('health.challenge.addConstant') }}
      </btn-pill>
    </div>

    <formula-comparation-selector
      class="selection-left"
      v-model="comparationVariable.model"
      :variables="getVariableReferences"
      :operators="comparationOperators"
      :variableOperations="variableOperations"
      :disabled="isAccumulatedMode"
      :isComparation="true"
    />
  </div>
</template>

<script>

import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faPlusCircle, faTimesCircle} from '@fortawesome/pro-solid-svg-icons';
import FormulaFieldSelector from 'BRAND/components/challenge/FormulaFieldSelector';
import FormulaComparationSelector from 'BRAND/components/challenge/FormulaComparationSelector';
import FormulaConstantField from 'BRAND/components/challenge/FormulaConstantField';

export default {
  name: 'ChallengeFormulaForm',
  components: {
    FormulaConstantField,
    FormulaComparationSelector,
    FontAwesomeIcon,
    BtnPill,
    FormulaFieldSelector
  },
  watch: {
    selectedVariables () {
      this.updateModel();
    },
    comparationVariable () {
      this.updateModel();
    }
  },
  props: {
    variableReferences: {
      type: Array,
      default: () => []
    },
    mode: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      selectedVariables: [],
      operators: [
        '+',
        '-',
        '*',
        '/'
      ],
      comparationOperators: [
        '=',
        '<',
        '<=',
        '>',
        '>='
      ],
      variableOperations: [
        {id: 'FIRST', label: this.$t('health.challenge.operatorTypes.first')},
        {id: 'LAST', label: this.$t('health.challenge.operatorTypes.last')},
        {id: 'COUNT', label: this.$t('health.challenge.operatorTypes.count')},
        {id: 'MIN', label: this.$t('health.challenge.operatorTypes.min')},
        {id: 'MAX', label: this.$t('health.challenge.operatorTypes.max')},
        {id: 'SUM', label: this.$t('health.challenge.operatorTypes.sum')},
        {id: 'AVG', label: this.$t('health.challenge.operatorTypes.avg')}
      ],
      comparationVariable: {},
      icon: {
        add: faPlusCircle,
        remove: faTimesCircle
      }
    };
  },
  computed: {
    getVariableReferences () {
      return this.variableReferences;
    },
    getSelectedVariables () {
      return this.selectedVariables;
    },
    isAccumulatedMode () {
      return this.mode != null && this.mode.id === 0;
    }
  },
  methods: {
    isAddButtonDisabled () {
      let disabled = false;
      const notConstantFieldsWithoutSelectedVariable = this.selectedVariables.filter(value => !value.isConstant && (value.model == null || value.model.variable == null || value.model.variable === ''));
      if (notConstantFieldsWithoutSelectedVariable.length > 0) {
        disabled = true;
      }
      return disabled;
    },
    isRemoveButtonDisabled (index) {
      // At least one variable
      return this.selectedVariables.length === 1 || index <= 0;
    },
    hideOperator (index) {
      return index <= 0;
    },
    onClickRemoveVariable (index) {
      this.selectedVariables.splice(index, 1);
    },
    onClickAddVariable () {
      if (this.isAddButtonDisabled()) {
        return;
      }
      this.selectedVariables.push({
        options: this.getVariableReferences,
        isConstant: false,
        model: undefined
      });
    },
    onClickAddConstant () {
      this.selectedVariables.push({
        options: this.getVariableReferences,
        isConstant: true,
        model: undefined
      });
    },
    updateModel () {
      const model = {
        variables: this.selectedVariables,
        comparationVariable: this.comparationVariable
      };
      this.$emit('input', model);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.selection-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $sp-margin-small;
}

.selection-right {
  font-size: $fs-xl;
  cursor: pointer;
  color: $primary;
}

.selection-right-disabled {
  font-size: $fs-xl;
  color: $primary;
}

.add-wrapper {
  margin-top: $sp-margin-small;
  margin-bottom: $sp-margin-larger;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/ChallengeFormulaForm.vue